module.exports = __webpack_public_path__ + "img/bread-easypay-fidelity.3faf13cf.png";